import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import "./index.css";
import TranslationService from "../../../services/translation/TransationService";

function ScoreTag({ scoreNumber }) {
  let tag;
  switch (scoreNumber) {
    case 5:
      tag = TranslationService.get("SCORES.5");
      break;
    case 4:
      tag = TranslationService.get("SCORES.4");
      break;
    case 3:
      tag = TranslationService.get("SCORES.3");
      break;
    case 2:
      tag = TranslationService.get("SCORES.2");
      break;
    case 1:
      tag = TranslationService.get("SCORES.1");
      break;
    default:
      tag = "";
  }

  const gridOffsets = [false, 2, 4, 6, 8];

  return (
    <Grid container>
      <Grid item xs={gridOffsets[scoreNumber - 1]} />
      <Grid item xs={4} className="tag">
        {tag}
      </Grid>
    </Grid>
  );
}

ScoreTag.propTypes = {
  scoreNumber: PropTypes.number.isRequired
};

export default ScoreTag;



// WEBPACK FOOTER //
// ./src/components/RatingScoreCard/ScoreTag/index.jsx